import {
  AdminTable,
  TableDataItem,
} from '@/components/layouts/events/AdminTable'
import { PageHelperText } from '@/components/ui'
import { Alert } from 'antd'

export interface PresetTemplate extends TableDataItem {
  templateName: string
  enabled: boolean
}

interface PresetMessagesTabProps {
  presetTemplates: PresetTemplate[]
  onTemplatesChange: (templates: PresetTemplate[]) => void
  eventSlug: string
  /** Labels of single-date / multi-date reminder pairs that are both enabled. */
  conflictingPairs?: string[]
}

export const PresetMessagesTab = ({
  presetTemplates,
  onTemplatesChange,
  eventSlug,
  conflictingPairs = [],
}: PresetMessagesTabProps) => {
  return (
    <div>
      <div className="mb-6">
        <PageHelperText>
          Toggle on to enable a WhatsApp blast to all recipients. Use the multi-date
          reminders for events that run across more than one date — they show a date
          range instead of a single day.
        </PageHelperText>
      </div>

      {conflictingPairs.length > 0 && (
        <Alert
          className="mb-6"
          type="warning"
          showIcon
          message="Duplicate reminders will be sent"
          description={
            <>
              These reminders fire at the same time, so every attendee receives both:
              <ul className="mt-1 list-disc pl-5">
                {conflictingPairs.map((pair) => (
                  <li key={pair}>{pair}</li>
                ))}
              </ul>
              Turn off whichever one does not match this event.
            </>
          }
        />
      )}

      <AdminTable<PresetTemplate>
        className="ava-data-table"
        columns={[
          {
            title: 'Template Name',
            dataIndex: 'templateName',
            sortable: true,
          },
          {
            title: 'Enabled',
            dataIndex: 'enabled',
            width: 150,
            sortable: true,
            type: 'switch',
          },
          {
            title: 'Actions',
            dataIndex: 'actions',
            width: 150,
            type: 'actions',
            actions: {
              editUrl: (record) =>
                `/events/${eventSlug}/messaging/whatsapp_blasts/preset/${record.key}/edit`,
              showEdit: true,
              showDelete: false,
              showView: false,
            },
          },
        ]}
        dataSource={presetTemplates}
        pagination={false}
        bordered={false}
        rowKey="key"
        onChange={onTemplatesChange}
      />
    </div>
  )
}
